import { useParams } from 'react-router-dom'
import { JobDetailContent } from '@/components/jobs/JobDetailContent'

// 2.3.6 Standalone /jobs/:id route. The full detail body (quick-action bar,
// tabs, action dialogs, attachments) lives in JobDetailContent, which is shared
// with the Agenda right-side drawer (variant='drawer'). This page renders the
// 'page' variant (back arrow to /calendar) and owns nothing else.
export default function JobDetailPage() {
  const { id = '' } = useParams<{ id: string }>()
  return <JobDetailContent id={id} variant='page' />
}
